export interface BlogPostMetadata {
    slug: string;
    title: string;
    excerpt: string;
    author: string;
    date: string;
    coverImage?: string;
    readTime: string;
    tags: string[];
}

import { metadata as post1 } from "./best-rent-keep-apps-2026";
import { metadata as post2 } from "./spreadsheets-vs-property-management-software";
import { metadata as post3 } from "./is-hiring-a-property-manager-worth-it";
import { metadata as post4 } from "./proptech-ai-revolutionizing-rent-management";
import { metadata as post5 } from "./top-5-features-rental-property-software";
import { metadata as post6 } from "./handle-late-rent-payments-professionally";
import { metadata as post7 } from "./tax-season-realities-landlords";
import { metadata as post8 } from "./essential-financial-metrics-mrr-arr-roi";
import { metadata as post9 } from "./navigating-security-deposits-deductions";
import { metadata as post10 } from "./automating-rental-portfolio-passive-income";
import { metadata as post11 } from "./streamline-tenant-onboarding-complete-checklist";
import { metadata as post12 } from "./screening-tenants-red-flags-landlords-should-spot";
import { metadata as post13 } from "./good-tenant-communication-higher-retention";
import { metadata as post14 } from "./complete-landlord-tenant-move-out-protocol";
import { metadata as post15 } from "./dealing-with-difficult-tenants-deescalation";
import { metadata as post16 } from "./managing-maintenance-requests-without-headache";
import { metadata as post17 } from "./write-a-rental-listing-attracts-high-quality-tenants";
import { metadata as post18 } from "./preventative-maintenance-checklist-single-family-rentals";
import { metadata as post19 } from "./scaling-real-estate-portfolio-1-to-10-properties";
import { metadata as post20 } from "./managing-multifamily-vs-single-family";

// Global registry of all blogs. We'll populate this later.
export const blogs: BlogPostMetadata[] = [
    post1, post2, post3, post4, post5, post6, post7, post8, post9, post10,
    post11, post12, post13, post14, post15, post16, post17, post18, post19, post20
];

export function getBlogBySlug(slug: string): BlogPostMetadata | undefined {
    return blogs.find((blog) => blog.slug === slug);
}
